module.exports = __webpack_public_path__ + "images/img-kw2IGmW.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/7.png
// module id = 2356
// module chunks = 0